// Score de complétude du profil entreprise (IA Readiness) — 0 à 100.
// Extrait de Settings.jsx pour être partagé (Settings, ProfileSpotlight, advice.js).
// Base de tous les conseils IA : plus le score est haut, plus les conseils passent
// de « remplis ton profil » à « fais vivre ta base ».
export function calcAiScore(f = {}) {
  let s = 0;
  // Identité (20 pts)
  if (f.name)                  s += 6;
  if (f.sector)                s += 6;
  if (f.logo_url)              s += 8;
  // Positionnement (34 pts)
  if (f.description)           s += 10;
  if (f.target_audience)       s += 10;
  if (f.services)              s += 8;
  if (f.unique_selling_point)  s += 4;
  if (f.values)                s += 2;
  // Contact & localisation (14 pts)
  if (f.website)               s += 4;
  if (f.address || f.city)     s += 4;
  if (f.business_phone || f.business_email) s += 3;
  if (f.geographic_zone)       s += 3;
  // Réseaux sociaux (20 pts)
  if (f.facebook_url)          s += 5;
  if (f.instagram_url)         s += 5;
  if (f.linkedin_url)          s += 4;
  if (f.google_mybusiness_url) s += 6;
  // Contexte marché (12 pts)
  if (f.avg_client_value)      s += 4;
  if (f.keywords)              s += 4;
  if (f.competitors)           s += 4;
  return Math.min(s, 100);
}

export default calcAiScore;
